var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClose20X20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m3.946 2.897.084.073L10 8.939l5.97-5.97a.75.75 0 0 1 1.133.977l-.073.084L11.061 10l5.97 5.97a.75.75 0 0 1-.977 1.133l-.084-.073L10 11.061l-5.97 5.97a.75.75 0 0 1-1.133-.977l.073-.084L8.939 10l-5.97-5.97a.75.75 0 0 1 .977-1.133"
})));
export default SvgIcClose20X20;